export default __webpack_public_path__ + "static/media/F0006.b68edb59.png";